import simg1 from '../images/service/img-1.jpg'
import simg2 from '../images/service/img-2.jpg'
import simg3 from '../images/service/img-3.jpg'
import simg4 from '../images/service/img-4.jpg'
import simg5 from '../images/service/img-5.jpg'
import simg6 from '../images/service/img-6.jpg'
import simg7 from '../images/service/img-7.jpg'

import singleImg1 from '../images/service-single/1.jpg'
import singleImg2 from '../images/service-single/2.jpg'
import singleImg3 from '../images/service-single/3.jpg'
import singleImg4 from '../images/service-single/4.jpg'
import singleImg5 from '../images/service-single/5.jpg'
import singleImg6 from '../images/service-single/6.jpg'
import singleImg7 from '../images/service-single/7.jpg'






const Services = [
    {
        id: '1',
        fIcon:'flaticon-food-tray',
        title:'Delicious Food',
        description:'Excepteur sint occaecat proident, sunt in culpa mollit est aborum.',
        simg1:simg1,
        ssImg:singleImg1,
    },
    {
        id: '2',
        fIcon:'flaticon-parking',
        title:'Parking Area',
        description:'Excepteur sint occaecat proident, sunt in culpa mollit est aborum.',
        simg1:simg2,
        ssImg:singleImg2,
    },
    {
        id: '3',
        fIcon:'flaticon-swimmer',
        title:'Swimming Pool',
        description:'Excepteur sint occaecat proident, sunt in culpa mollit est aborum.',
        simg1:simg3,
        ssImg:singleImg3,
    },
    {
        id: '4',
        fIcon:'flaticon-mortar',
        title:'Spa Salon',
        description:'Excepteur sint occaecat proident, sunt in culpa mollit est aborum.',
        simg1:simg4,
        ssImg:singleImg4,
    },
    {
        id: '5',
        fIcon:'flaticon-dumbell',
        title:'Exercise Space',
        description:'Excepteur sint occaecat proident, sunt in culpa mollit est aborum.',
        simg1:simg5,
        ssImg:singleImg5,
    },
    {
        id: '6',
        fIcon:'flaticon-wifi',
        title:'Free Wifi',
        description:'Excepteur sint occaecat proident, sunt in culpa mollit est aborum.',
        simg1:simg6,
        ssImg:singleImg6,
    },
    {
        id: '7',
        fIcon:'flaticon-cappuccino',
        title:'Breakfast',
        description:'Excepteur sint occaecat proident, sunt in culpa mollit est aborum.',
        simg1:simg7,
        ssImg:singleImg7,
    },
    {
        id: '8',
        fIcon:'flaticon-more',
        title:'Other Service',
        description:'Excepteur sint occaecat proident, sunt in culpa mollit est aborum.',
        simg1:simg1,
        ssImg:singleImg1,
    }
]
export default Services;